import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { LegalDocumentComponent } from './components/legal-document.component';
import { LegalDocumentRoutingModule } from './legal-document-routing.module';

@NgModule({
  declarations: [LegalDocumentComponent],
  imports: [
    LegalDocumentRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class LegalDocumentModule {}

export function loadLegalDocumentModuleAsChild() {
  return Promise.resolve(LegalDocumentModule);
}
